module.exports = __webpack_public_path__ + "static/Lato-BoldItalic-f98d18040a766b7bc4884b8fcc154550.ttf";